import React from 'react';

export { Table } from './table';
export { AsyncTable } from './async';
export { AsyncTable as default } from './async';
export { TableDropdown } from './table-dropdown';

export const TableRow = ({ children }: { children: React.ReactNode }) => (
  <div className="Table__Row">{children}</div>
);

export const TableCell = ({ children, className }: { children: React.ReactNode, className?: string }) => (
  <div className={`Table__Cell${className ? ` ${className}` : ''}`}>{children}</div>
);
